import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/travis/gopath/src/github.com/rumblefrog/source-chat-relay/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
import PreviewGIF from '~assets/preview_2.gif';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "source-chat-relay"
    }}>{`Source Chat Relay`}</h1>
    <p><a parentName="p" {...{
        "href": "https://travis-ci.com/rumblefrog/source-chat-relay"
      }}><img alt="Travis CI" src="https://img.shields.io/travis/com/rumblefrog/source-chat-relay.svg?style=for-the-badge" /></a>{`
`}<a parentName="p" {...{
        "href": "https://discord.gg/TZ4BsrQ"
      }}><img alt="Discord" src="https://img.shields.io/discord/443915420324331521.svg?style=for-the-badge" /></a>{`
`}<a parentName="p" {...{
        "href": "https://github.com/rumblefrog/source-chat-relay/issues"
      }}><img alt="Issues" src="https://img.shields.io/github/issues/rumblefrog/source-chat-relay.svg?style=for-the-badge" /></a>{`
`}<a parentName="p" {...{
        "href": "https://github.com/rumblefrog/source-chat-relay/blob/master/LICENSE"
      }}><img alt="License" src="https://img.shields.io/github/license/rumblefrog/source-chat-relay.svg?style=for-the-badge" /></a></p>
    <a href="https://www.patreon.com/bePatron?u=962681"><img src={'become_a_patron_button.png'} alt="Patreon" height="32" /></a>
    <div>
    <img src={PreviewGIF} alt="Preview" />
    </div>
    <p>{`Communicate between Discord & In-Game, monitor server without being in-game, control the flow of messages and user base engagement!`}</p>
    <h2 {...{
      "id": "features"
    }}>{`Features`}</h2>
    <ul>
      <li parentName="ul">{`Receive and send messages bidrectionally`}</li>
      <li parentName="ul">{`Channel and type configuration for powerful setups`}</li>
      <li parentName="ul">{`Setup is incrediblily easy with Discord bot commands and simple config files`}</li>
      <li parentName="ul">{`Upon disconnect, game servers will attempt to reconnect at a fixed interval`}</li>
      <li parentName="ul">{`Filter out certain unwanted messages using regex expressions`}</li>
      <li parentName="ul">{`Set ingame prefixes to send a message with ability to configure flag permission for the prefix`}</li>
      <li parentName="ul">{`Natives to expand upon the functionality of the plugin `}{`(`}{`Custom events, team chat only relays, etc`}{`)`}</li>
    </ul>
    <h2 {...{
      "id": "prerequisites"
    }}>{`Prerequisites`}</h2>
    <ul>
      <li parentName="ul">{`A server to host the relay medium on (MySQL required)`}</li>
      <li parentName="ul">{`Source game server with the `}<a parentName="li" {...{
          "href": "https://forums.alliedmods.net/showthread.php?t=67640"
        }}>{`socket`}</a>{` extension`}</li>
      <li parentName="ul">{`A Discord bot token (`}<a parentName="li" {...{
          "href": "https://discordapp.com/developers/applications/"
        }}>{`https://discordapp.com/developers/applications/`}</a>{`)`}<blockquote parentName="li">
          <p parentName="blockquote">{`Please note that client ID and bot token is not the same thing`}</p>
        </blockquote></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      